module.exports = __webpack_public_path__ + "media/images/emblems/Montagny-pres-Yverdon-coat_of_arms-43806646995d9e2944425b81f65426e3.svg";